import React from 'react';
import './Calendar.css';

function Calendar() {
    const events2026 = [
        { date: "January 4", event: "Ekadasi - Saphala Ekadasi", type: "fasting" },
        { date: "January 13", event: "Pausha Purnima", type: "celebration" },
        { date: "January 19", event: "Ekadasi - Putrada Ekadasi", type: "fasting" },
        { date: "February 3", event: "Ekadasi - Sat-tila Ekadasi", type: "fasting" },
        { date: "February 11", event: "Varaha Dvadasi", type: "appearance" },
        { date: "February 17", event: "Ekadasi - Bhaimi Ekadasi", type: "fasting" },
        { date: "February 22", event: "Gaura Purnima Eve", type: "celebration" },
        { date: "February 23", event: "Gaura Purnima - Appearance of Lord Chaitanya", type: "appearance" },
        { date: "March 4", event: "Ekadasi - Amalaki Ekadasi", type: "fasting" },
        { date: "March 19", event: "Ekadasi - Papmochani Ekadasi", type: "fasting" },
        { date: "March 27", event: "Ram Navami - Appearance of Lord Ramachandra", type: "appearance" },
        { date: "April 3", event: "Ekadasi - Kamada Ekadasi", type: "fasting" },
        { date: "April 18", event: "Ekadasi - Varuthini Ekadasi", type: "fasting" },
        { date: "May 3", event: "Ekadasi - Mohini Ekadasi", type: "fasting" },
        { date: "May 12", event: "Nrsimha Chaturdasi - Appearance of Lord Nrsimhadeva", type: "appearance" },
        { date: "May 18", event: "Ekadasi - Apara Ekadasi", type: "fasting" },
        { date: "June 2", event: "Ekadasi - Pandava Nirjala Ekadasi", type: "fasting" },
        { date: "June 16", event: "Ekadasi - Yogini Ekadasi", type: "fasting" },
        { date: "June 18", event: "Snana Yatra - Bathing Ceremony of Lord Jagannath", type: "celebration" },
        { date: "July 2", event: "Ratha Yatra - Cart Festival of Lord Jagannath", type: "festival" },
        { date: "July 16", event: "Ekadasi - Sayana Ekadasi", type: "fasting" },
        { date: "July 31", event: "Ekadasi - Kamika Ekadasi", type: "fasting" },
        { date: "August 7", event: "Guru Purnima - Appearance of Srila Vyasadeva", type: "appearance" },
        { date: "August 15", event: "Ekadasi - Pavitra Ekadasi", type: "fasting" },
        { date: "August 16", event: "Janmashtami Eve - Rohini Fasting", type: "fasting" },
        { date: "August 17", event: "Sri Krishna Janmashtami - Appearance of Lord Krishna", type: "appearance" },
        { date: "August 18", event: "Nandotsava - Celebration at Nanda's House", type: "celebration" },
        { date: "August 30", event: "Ekadasi - Aja Ekadasi", type: "fasting" },
        { date: "September 5", event: "Radhashtami - Appearance of Srimati Radharani", type: "appearance" },
        { date: "September 7", event: "Appearance of Srila Bhaktivinoda Thakura", type: "appearance" },
        { date: "September 14", event: "Ekadasi - Parsva Ekadasi", type: "fasting" },
        { date: "September 29", event: "Ekadasi - Indira Ekadasi", type: "fasting" },
        { date: "October 14", event: "Ekadasi - Pasankusa Ekadasi", type: "fasting" },
        { date: "October 20", event: "Disappearance of Srila Bhaktivinoda Thakura", type: "disappearance" },
        { date: "October 28", event: "Ekadasi - Rama Ekadasi", type: "fasting" },
        { date: "November 3", event: "Gopastami", type: "celebration" },
        { date: "November 5", event: "Disappearance of Srila Prabhupada", type: "disappearance" },
        { date: "November 13", event: "Ekadasi - Utthana Ekadasi", type: "fasting" },
        { date: "November 27", event: "Ekadasi - Utpanna Ekadasi", type: "fasting" },
        { date: "December 13", event: "Ekadasi - Moksada Ekadasi", type: "fasting" },
        { date: "December 27", event: "Ekadasi - Saphala Ekadasi", type: "fasting" }
    ];

    const getEventIcon = (type) => {
        switch (type) {
            case 'appearance': return '🎂';
            case 'fasting': return '🌙';
            case 'celebration': return '🎉';
            case 'festival': return '🎊';
            case 'disappearance': return '🙏';
            default: return '📅';
        }
    };

    const getEventColor = (type) => {
        switch (type) {
            case 'appearance': return '#4caf50';
            case 'fasting': return '#2196f3';
            case 'celebration': return '#ff9800';
            case 'festival': return '#e91e63';
            case 'disappearance': return '#9c27b0';
            default: return '#607d8b';
        }
    };

    const groupEventsByMonth = () => {
        const grouped = {};
        events2026.forEach(event => {
            const month = event.date.split(' ')[0];
            if (!grouped[month]) {
                grouped[month] = [];
            }
            grouped[month].push(event);
        });
        return grouped;
    };

    const monthlyEvents = groupEventsByMonth();

    return (
        <div className="calendar-page">
            <h1 className="page-title">📅 Vaisnava Calendar 2026 📅</h1>

            <div className="calendar-intro">
                <p>
                    Stay connected with important Vaisnava festivals, appearance days, and fasting days
                    throughout the year 2026. Plan your spiritual observances and celebrate these auspicious
                    occasions with fellow devotees.
                </p>
            </div>

            <div className="legend">
                <h3>Event Types:</h3>
                <div className="legend-items">
                    <div className="legend-item">
                        <span className="legend-icon">🎂</span>
                        <span>Appearance Days</span>
                    </div>
                    <div className="legend-item">
                        <span className="legend-icon">🌙</span>
                        <span>Ekadasi Fasting</span>
                    </div>
                    <div className="legend-item">
                        <span className="legend-icon">🎉</span>
                        <span>Celebrations</span>
                    </div>
                    <div className="legend-item">
                        <span className="legend-icon">🎊</span>
                        <span>Festivals</span>
                    </div>
                    <div className="legend-item">
                        <span className="legend-icon">🙏</span>
                        <span>Disappearance Days</span>
                    </div>
                </div>
            </div>

            <div className="months-container">
                {Object.entries(monthlyEvents).map(([month, events]) => (
                    <div key={month} className="month-section">
                        <h2 className="month-title">{month} 2026</h2>
                        <div className="events-list">
                            {events.map((event, index) => (
                                <div
                                    key={index}
                                    className="event-card"
                                    style={{ borderLeftColor: getEventColor(event.type) }}
                                >
                                    <div className="event-icon">{getEventIcon(event.type)}</div>
                                    <div className="event-details">
                                        <div className="event-date">{event.date}</div>
                                        <div className="event-name">{event.event}</div>
                                    </div>
                                    <div
                                        className="event-type-badge"
                                        style={{ background: getEventColor(event.type) }}
                                    >
                                        {event.type}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>

            <div className="important-notes">
                <h3>📝 Important Notes:</h3>
                <ul>
                    <li><strong>Ekadasi Fasting:</strong> Devotees observe fasting from grains and beans on Ekadasi days</li>
                    <li><strong>Appearance Days:</strong> Special celebrations with abhisheka, kirtans, and feasts</li>
                    <li><strong>Janmashtami:</strong> The most important festival celebrating Lord Krishna's appearance</li>
                    <li><strong>Gaura Purnima:</strong> Celebration of Lord Chaitanya Mahaprabhu's appearance</li>
                    <li><strong>Ratha Yatra:</strong> The grand chariot festival of Lord Jagannath</li>
                    <li><strong>Local Variations:</strong> Some dates may vary by location; please check with your local ISKCON temple</li>
                </ul>
            </div>

            <div className="calendar-footer">
                <h3>🕉️ Hare Krishna!</h3>
                <p>
                    May all these auspicious days bring you closer to Lord Krishna and fill your life with
                    spiritual joy and advancement. Remember to chant the Hare Krishna maha-mantra daily
                    and serve the devotees with love and humility.
                </p>
            </div>
        </div>
    );
}

export default Calendar;
